export default __webpack_public_path__ + "static/media/saint_aubin8.5a9cc0fb.jpg";